'use strict';

var eventInfo = require('../events/event-info.cjs');
var Feature = require('../motion/features/Feature.cjs');
var hover = require('../../../../../../motion-dom/dist/es/gestures/hover.cjs');
var frame = require('../../../../../../motion-dom/dist/es/frameloop/frame.cjs');

function handleHoverEvent(node, event, lifecycle) {
    const { props } = node;
    if (node.animationState && props.whileHover) {
        node.animationState.setActive("whileHover", lifecycle === "Start");
    }
    const eventName = ("onHover" + lifecycle);
    const callback = props[eventName];
    if (callback) {
        frame.frame.postRender(() => callback(event, eventInfo.extractEventInfo(event)));
    }
}
class HoverGesture extends Feature.Feature {
    mount() {
        const { current } = this.node;
        if (!current)
            return;
        this.unmount = hover.hover(current, (_element, startEvent) => {
            handleHoverEvent(this.node, startEvent, "Start");
            return (endEvent) => handleHoverEvent(this.node, endEvent, "End");
        });
    }
    unmount() { }
}

exports.HoverGesture = HoverGesture;
//# sourceMappingURL=hover.cjs.map
